import "./Navbar.css";

import { Link } from "react-router-dom";
export default function Navbar() {
  return (
    <main id="main-doc">
      <nav id="nav-bar">
        <a
          href="https://github.com/Rahul-Sahani04/"
          target="_blank"
          id="nav-link"
          rel="noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/25/25231.png"
            id="nav-img"
            alt="GitHubProfile"
          />
        </a>
        <ul id="nav-ul">
          <Link to="/" class="nav-point">
            <li id="nav-li">Home</li>
          </Link>
          <a
            href="https://github.com/Rahul-Sahani04/"
            target="_blank"
            rel="noreferrer"
          >
            <li id="nav-li">About Me</li>
          </a>
          <a href="#projects">
            <li id="nav-li">Projects</li>
          </a>
          {/* <a href="#">
                <li id="nav-li">Contacts</li>
              </a> */}
        </ul>
      </nav>
    </main>
  );
}
